<div class="container-fluid container-footer">
  <div class="row">
    <div class="col-12 col-lg-3 col-md-3">
      <img src="/assets/government-logo.png" class="gov-logo" alt="" />
    </div>
    <div class="col-12 col-lg-3 col-md-3 p-3">
      <h4 class="heading"><strong>REPUBLIC OF THE PHILIPPINES</strong></h4>
      <p class="text">
        All Content is in the public domain unless otherwise stated
      </p>
    </div>
    <div class="col-12 col-lg-3 col-md-3 p-3">
      <h4 class="heading"><strong>ABOUT GOVPH</strong></h4>
      <p class="text mb-3">
        Learn more about the Philippine government, its structure, how
        government works and the people behind it
      </p>
      <div class="div">
        <a href="https://www.gov.ph/" target="_blank">GOV.PH</a>
      </div>
      <div class="div">
        <a href="https://data.gov.ph/index/home" target="_blank"
          >Open Data Portal</a
        >
      </div>
      <div class="div">
        <a href="https://www.officialgazette.gov.ph/" target="_blank"
          >Official Gazette</a
        >
      </div>
    </div>
    <div class="col-12 col-lg-3 col-md-3 p-3">
      <h4 class="heading"><strong>GOVERNMENT LINKS</strong></h4>
      <div>
        <a href="https://ovp.gov.ph/" target="_blank">
          Office of the Vice President
        </a>
      </div>
      <div class="div">
        <a href="http://legacy.senate.gov.ph/" target="_blank"
          >Senate of the Philippines</a
        >
      </div>
      <div class="div">
        <a href="https://www.congress.gov.ph/" target="_blank"
          >House of Representatives</a
        >
      </div>
      <div class="div">
        <a href="https://sc.judiciary.gov.ph/" target="_blank">Supreme Court</a>
      </div>
      <div class="div">
        <a href="https://ca.judiciary.gov.ph/" target="_blank"
          >Court of Appeals</a
        >
      </div>
      <div class="div">
        <a href="https://sb.judiciary.gov.ph/" target="_blank">Sandiganbayan</a>
      </div>
    </div>
  </div>
</div>
